import { armorAPI } from '~/services/api';

const get = () =>
  armorAPI.request({
    method: 'GET',
    url: `/setting/notifications`,
  });

const put = (data) =>
  armorAPI.request({
    data,
    method: 'PUT',
    url: `/setting/notifications`,
  });

const sendSampleEmail = (notificationType) =>
  armorAPI.request({
    data: { notification_type: notificationType },
    method: 'POST',
    url: `/order-notifications/send-sample`,
  });

export { get, put, sendSampleEmail };
